export default __webpack_public_path__ + "static/media/modem.59c4056c.webp";